// src/App.jsx

// ----------------------------------------------------------------------
// 1. IMPORTACIONES NECESARIAS
// ----------------------------------------------------------------------
import React, { useState, useEffect } from 'react';

// Importamos los componentes de React Router para manejar la navegación
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Importamos los componentes de "layout" (se ven en todas las páginas)
import Spinner from './components/Spinner';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Importamos los componentes de "página" (cambian según la URL)
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';


// Importamos el archivo CSS principal de la aplicación
import './App.css';

// Importamos la librería para las animaciones al hacer scroll (WOW.js)
import WOW from 'wow.js';


// ----------------------------------------------------------------------
// 2. COMPONENTE PRINCIPAL DE LA APLICACIÓN
// ----------------------------------------------------------------------
function App() {
  // ----------------------------------------------------------------------
  // 3. ESTADOS (useState) - Para controlar la interfaz dinámicamente
  // ----------------------------------------------------------------------
  const [isLoading, setIsLoading] = useState(true); // Controla el spinner de carga
  const [isSticky, setIsSticky] = useState(false); // Controla la sombra del navbar al hacer scroll
  const [showBackToTop, setShowBackToTop] = useState(false); // Controla la visibilidad del botón "Volver arriba"


  // ----------------------------------------------------------------------
  // 4. EFECTOS (useEffect) - Para manejar "efectos secundarios"
  // ----------------------------------------------------------------------

  // Efecto para el Spinner: Se ejecuta una vez cuando la app se monta
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Después de 1 segundo, oculta el spinner
    }, 1000);

    // Función de limpieza: Cancela el temporizador si el componente se desmonta antes de 1s
    return () => clearTimeout(timer);
  }, []); // El array vacío [] significa "ejecutar solo una vez al montar"

  // Efecto para el Scroll: Controla el navbar sticky y el botón de volver arriba
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsSticky(true);
        setShowBackToTop(true);
      } else {
        setIsSticky(false);
        setShowBackToTop(false);
      }
    };

    // Añadimos el "escuchador" de eventos al scroll de la ventana
    window.addEventListener('scroll', handleScroll);

    // Función de limpieza: MUY IMPORTANTE. Quita el escuchador cuando el componente se desmonta para evitar fugas de memoria.
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // También se ejecuta solo una vez

  // Efecto para inicializar las animaciones WOW.js
  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);


  // ----------------------------------------------------------------------
  // 5. FUNCIONES AUXILIARES
  // ----------------------------------------------------------------------
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Hace que el scroll sea suave
    });
  };


  // ----------------------------------------------------------------------
  // 6. RENDERIZADO DEL JSX (Lo que se ve en pantalla)
  // ----------------------------------------------------------------------
  return (
    <>
      {/* Muestra el Spinner solo si `isLoading` es true */}
      {isLoading && <Spinner />}

      {/* BrowserRouter envuelve toda la aplicación para habilitar el enrutamiento */}
      <BrowserRouter>
        {/* Componentes fijos que aparecen en todas las páginas */}
        <Topbar />
        {/* Pasamos el estado `isSticky` como "prop" al Navbar para que aplique la clase CSS dinámicamente */}
        <Navbar isSticky={isSticky} />

        {/* Aquí se renderiza el componente de página correspondiente a la URL actual */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Aquí podrías añadir más rutas en el futuro, como /quote, /team, etc. */}
        </Routes>

        {/* El Footer también es un componente fijo */}
        <Footer />

        {/* Muestra el botón "Volver arriba" solo si `showBackToTop` es true */}
        {showBackToTop && (
          <a 
            href="#" 
            className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top" 
            onClick={(e) => {
              e.preventDefault(); // Evita que la página salte a # antes de hacer scroll
              scrollToTop();
            }}
          >
            <i className="bi bi-arrow-up"></i>
          </a>
        )}
      </BrowserRouter>
    </>
  );
}

export default App;